






































































































import Vue, { PropType } from 'vue'
import { Row } from '@/types/row'
import moment from 'moment'

export default Vue.extend({
  name: 'Teaser',
  props: {
    teaser: Object as PropType<Row>,
    horizontal: Boolean,
    images: Boolean,
    tagName: String,
    tag1hidden: {
      type: String
    },
    tag2hidden: {
      type: String
    },
    tag3hidden: {
      type: String
    },
    label1hidden: {
      type: String
    },
    label2hidden: {
      type: String
    }
  },
  methods: {
    getDateTime () {
      const today = new Date()
      const date = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate()
      return date
    },
    startHour (openingHour: string): string {
      const startHour = openingHour ? openingHour?.split(' - ')[0] : ''
      return startHour
    },
    endHour (openingHour: string): string {
      const endHour = openingHour ? openingHour?.split(' - ')[1] : ''
      return endHour
    }
  },
  computed: {
    moment: () => moment,
    label (): string {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const { label_1, label_2, label1hidden, label2hidden } = this.teaser
      // eslint-disable-next-line @typescript-eslint/camelcase
      const label1 = (label1hidden === undefined || label1hidden === 'false') ? label_1 : ''
      // eslint-disable-next-line @typescript-eslint/camelcase
      const label2 = (label2hidden === undefined || label2hidden === 'false') ? label_2 : ''

      return [label1, label2].filter(l => !!l).join(' - ')
    },
    tags (): string[] {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const { tag_1, tag_2, tag_3, tag1hidden, tag2hidden, tag3hidden } = this.teaser
      const tag1 = (tag1hidden === undefined || tag1hidden === 'false') ? [...tag_1?.split(',') || []] : []
      const tag2 = (tag2hidden === undefined || tag2hidden === 'false') ? [...tag_2?.split(',') || []] : []
      const tag3 = (tag3hidden === undefined || tag3hidden === 'false') ? [...tag_3?.split(',') || []] : []
      return [...tag1, ...tag2, ...tag3].filter(t => !!t).map(t => t.trim())
    },
    openingHours (): string[] {
      // eslint-disable-next-line @typescript-eslint/camelcase
      const { openingsuren } = this.teaser
      const openingHours = [...openingsuren?.split(',') || []]
      return openingHours
    },
    readMore (): string {
      return this.teaser?.lees_meer || (this.teaser?.recordid ? `#${this.teaser.recordid}` : '#')
    },
    /**
     * Determines if the "Lees meer" link should be shown.
     */
    showReadMore (): boolean {
      return !!(
        this.teaser.lees_meer || // Always show if external read more link exists
        (this.teaser.recordid && (this.teaser.beschrijving || this.teaser.image_url)) // Show only if recordid exists & has description or image
      )
    }
  }
})
